{
  "app": {
    "adblock": {
      "title": "広告ブロックソフトウェアを無効にしてください",
      "text": "アッドブロックなどのブラウザ拡張機能により、このアプリケーションが正しく動作しなくなります。今すぐ無効にしてください。",
      "done": "完了−アプリを再読み込みしてください"
    }
  },
  "campaign": {
    "targetType": {
      "LOCAL": "日本人ユーザー",
      "CHINESE_TOURISTS": "中国人観光客",
      "all": "すべて"
    },
    "stats": {
      "reportType": {
        "week": "週",
        "day": "日",
        "market": "市場",
        "media": "メディア",
        "format": "フォーマット",
        "creative": "クリエイティブ"
      }
    }
  },
  "page": {
    "summary": {
      "sendForReviewHint1": "「レビューのために送信」ボタンをクリックすると、送信を変更できません",
      "sendForReviewHint2": "変更が必要な場合は、Cosmoseアカウントマネージャーにお問い合わせください。",
      "downloadSpotplan": "スポットプランをダウンロードする",
      "budgetSplitQuestion": "予算をどのように分配しますか",
      "totalCampaignBudget": "キャンペーンの総予算"
    },
    "login": {
      "title": "ログイン",
      "forgotPassword": "パスワードをお忘れですか？",
      "credentialsError": "間違った資格情報。 再試行。",
      "accountIssue": "アカウントに問題があるため、ログインできません。 サポートチームにお問い合わせください。",
      "enterACode": "コード入力",
      "next": "進む",
      "back": "戻る",
      "2faTitle": "2段階認証",
      "2faSubtitle": "Google認証システムアプリから確認コードを取得",
      "invalidToken": "不正なコードを発見しました。 再試行してください。"
    },
    "resetPassword": {
      "title": "メールアドレスを入力してください",
      "description": "パスワードをリセットするためのリンクが送信されます。",
      "enterNewPassword": "新しいパスワードを入力してください",
      "passwordChanged": "パスワードが正常に変更されました",
      "thankYou": "ありがとうございました。",
      "goToLoginScreen": "ログイン画面に移動",
      "error401": "間違った資格情報。 再試行。",
      "patternConstraints": "パスワードは、少なくとも1つの数字、1つの小文字、1つの大文字を含める必要があります。",
      "lengthConstraints": "パスワードの最小長は、12文字以上である必要があります。"
    },
    "objective": {
      "localAudience": {
        "targetGroup": "ローカルオーディエンス",
        "title": "あなたの目標は何ですか？"
      },
      "chineseTourists": {
        "targetGroup": "中国人観光客",
        "title": "ターゲット地域はどこですか？"
      },
      "title": "あなたの目標は何ですか？",
      "chooseStrategy": "戦略を選ぶ",
      "iNeedSomeGuidance": "ガイダンスが必要です",
      "startFromScratch": "ゼロから始めます",
      "iFeelLikeAPro": "私はプロのように感じます",
      "createYourOwnGoal": "独自の目標を作成する",
      "goalName": "目標名",
      "egNewProductLaunch": "例えば新商品の発売",
      "target": "ターゲット",
      "clients": {
        "selectClient": "クライアントを選択",
        "addNewClient": "新しい顧客を追加する"
      }
    },
    "campaign": {
      "createCampaign": "キャンペーンを作成",
      "addNewPlatform": "新しいプラットフォームを追加",
      "globalCampaignLink": "グローバルキャンペーンリンク",
      "addFormat": "形式を追加",
      "platformSetup": "プラットフォームのセットアップ",
      "noResult": "申し訳ありませんが、結果は見つかりませんでした。",
      "saveSuccess": "キャンペーンは正常に保存されました！",
      "updateError": "申し訳ありませんが、変更は保存されませんでした！",
      "noSavedChanges": "まだ保存されていない変更を加えました。",
      "operationSuccess": "操作は正常に完了しました！",
      "publishSuccess": "キャンペーンが正常に設定されました！",
      "submitForReviewSuccess": "キャンペーン「{{campaignName}}」はレビューのため送信されました",
      "submitForReviewContact": "Cosmoseアカウントマネージャーから4営業時間後にメールでご連絡します",
      "deleteSuccess": "キャンペーンは正常に削除されました！",
      "estimatesTip": "これは、ターゲットオーディエンス規模の推定です。 ユーザーがアクセスする店舗、人口統計、プラットフォーム固有の設定などのパラメーターを調整すると、動的に変化します。",
      "rejectedCampaignBy": "あなたのキャンペーンは「by」により拒否されました",
      "timezone": "日付は現地時間で表示されます。",
      "budgetTip": "提示された値は予算の見積もりです。 計算は、オーディエンス規模と追加のパラメーター-平均表示頻度とリーチ率にCPMを掛けたものに基づいています。 この金額には、位置情報サービスの使用料も含まれています。",
      "estimatedAudienceSize": "オーディエンス規模の推定",
      "estimatedAudienceSizeCalculating": "推定オーディエンス数を計算しています...",
      "details": "詳細",
      "searchCampaignByName": "キャンペーン名で検索"
    },
    "campaigns": {
      "title": "ようこそ！",
      "localCampaign": "ローカルキャンペーン",
      "chineseTouristsCampaign": "中国人観光客キャンペーン"
    },
    "report": {
      "metricsTooltips": {
        "backToAllMetrics": "すべての指標に戻る",
        "conversions": "キャンペーンの完了後、コンバージョンデータが遅れて表示されます。"
      },
      "campaignReport": "Campaign report.xlsx",
      "downloadReport": "レポートをダウンロードする",
      "postBuyReport": "購入後レポートをダウンロードする",
      "summary": "概要",
      "keyMetrics": "主要な指標",
      "overview": "概要",
      "adSetMetrics": "広告セットの指標",
      "engagement": "エンゲージメント",
      "peopleReached": "到達した人々",
      "individualCustomerVisits": "個々の顧客訪問",
      "delayDataTip": "レポートのデータは、データパートナーによって処理されてから遅れて表示されます。",
      "impressions": "インプレッション",
      "clicks": "クリック数",
      "clickThroughRate": "CTR",
      "uniqueViews": "UV",
      "averageFrequency": "平均フリークエンシー",
      "costPerMille": "CPM",
      "costPerClick": "CPC",
      "details": "詳細",
      "organicTraffic": "オーガニックトラフィック",
      "noDataMessage": "使用可能なレポートデータはまだありません",
      "conversions": "コンバージョン数",
      "metricsType": {
        "all": "すべての指標",
        "impressions": "インプレッション",
        "clicks": "クリック数",
        "clickThroughRate": "CTR",
        "uniqueViews": "UV",
        "averageFrequency": "広告接触頻度",
        "costPerMille": "CPM",
        "costPerClick": "CPC",
        "conversions": "コンバージョン数",
        "postComments": "コメントを投稿する",
        "postEngagements": "エンゲージメント後",
        "postReactions": "事後反応",
        "postShares": "株式を投稿する",
        "onlineConversions": "ウェブサイト購入",
        "videoP100watchedActions": "100% Video view",
        "videoP25watchedActions": "25% Video view",
        "videoP50watchedActions": "50% Video view",
        "videoP75watchedActions": "75% Video view",
        "videoP99watchedActions": "99% Video view"
      },
      "postComments": "広告に対するコメント数",
      "postEngagements": "広告に対するエンゲージメント数",
      "postReactions": "広告に対するいいねなどのリアクション数",
      "postShares": "広告がシェアされた数",
      "filterBy": "「by」でフィルタします。",
      "filter": "フィルタ",
      "brandPreferences": {
        "showBrandPreferences": "「for」のブランド選好度を表示する",
        "tooltip": "提示されたデータは、キャンペーン期間の開始以来収集されています"
      },
      "uploadStats": "統計をアップロードする",
      "uploadStatsSuccess": "統計が正しくアップロードされました！",
      "All segments": "すべてのセグメントを選択する",
      "onlineConversions": "ウェブサイト購入",
      "videoP100watchedActions": "100% Video view",
      "videoP25watchedActions": "25% Video view",
      "videoP50watchedActions": "50% Video view",
      "videoP75watchedActions": "75% Video view",
      "videoP99watchedActions": "99% Video view"
    },
    "planner": {
      "downloadLocationsList": "場所のリストをダウンロードする",
      "downloadBudget": "予算見積書をダウンロードする",
      "downloadRequirements": "要件をダウンロードする",
      "platformGroup": {
        "selectAll": "すべて選択",
        "deselectAll": "すべての選択を解除",
        "details": "詳細"
      },
      "label": {
        "BEFORE_TRIP": "旅行前",
        "DURING_TRIP": "旅行中"
      },
      "nav": {
        "audience": "オーディエンス",
        "groups": "特徴",
        "timeline": "実行期間",
        "budget": "予算",
        "media": "メディア"
      },
      "groups": {
        "title": "グループ",
        "question": "どのグループにリーチしますか？",
        "addInterests": "関心分野を追加+",
        "addAnother": "別のものを追加+",
        "income": "所得",
        "interests": "関心分野",
        "searchBehaviour": "検索動向",
        "educationLevel": "学歴",
        "targetMarkets": "どの都市をターゲットにしますか？",
        "specificCities": "特定の都市",
        "nationWide": "全国"
      },
      "budget": {
        "title": "予算",
        "question": "キャンペーンの予算はおいくらですか？",
        "withThisBudgetYouCanReach": "この予算で",
        "ofTargetAudience": "のターゲットオーディエンスにリーチできます。",
        "resetWithThisBudget": "この予算で再設定します。",
        "resetToDefaultSetup": "設定のリセット",
        "budgetTooLow": "予算が低くすぎます",
        "howWouldYouLikeToSplitBudget": "予算をどのように分割しますか？",
        "totalCampaignBudget": "キャンペーンの総予算",
        "disabledDuringtripTip": "キャンペーンは「旅行中」フェーズでのみ実行されます",
        "minBudgetHint": "最小予算は{{value}}です",
        "changedBudgetHint": "「続行」する前に、まず予算を「適用」してください。",
        "maxBudgetHint": "最大予算は{{value}}です",
        "apply": "承認"
      },
      "timeline": {
        "title": "タイムライン",
        "question": "キャンペーンのスケジュールは何ですか？",
        "spotplan": {
          "media": "メディア",
          "adFormat": "広告フォーマット",
          "audienceExplanation": "オーディエンスの概要",
          "regionAndSchedule": "地域とスケジュール",
          "potentialCustmersReached": "見込み客に到達（推定）",
          "buyingModel": "購入モデル",
          "averageFrequency": "広告接触頻度",
          "numberOfImpressions": "インプレッション数",
          "maxUnitPrice": "最大単価",
          "cosmoseAiDataFee": "Cosmose AIデータ料金",
          "cosmoseAiDataFeeLocations": "1〜500か所",
          "cosmoseServiceFee": "Cosmoseサービス料",
          "cosmoseServiceFeeInvestment": "純メディア投資の3％",
          "totalBudgetIncludingVat": "合計予算（6％のVATを含む）",
          "campaign": "キャンペーン",
          "campaignId": "キャンペーン ID",
          "cities": "都市",
          "locations": "ロケーション",
          "campaignDate": "キャンペーン日",
          "channel": "チャンネル",
          "format": "フォーマット",
          "unit": "ユニット（購入モデル）",
          "totalUnits": "合計",
          "pricePerUnit": "単位当たりの価格",
          "totalCost": "総費用",
          "estImpressions": "推定インプレッション",
          "estClicks": "推定クリック数",
          "estCtr": "推定CTR",
          "estimatedCostPerClick": "推定CPC"
        }
      },
      "audience": {
        "moreCompetitors": "より多くの競合他社",
        "addAnother": "他の競合他社を追加+",
        "title": "オーディエンス",
        "question": "ターゲットオーディエンスはどこで買い物をしますか？",
        "audienceLikelyToGoShopping": "買い物に行く可能性が高いオーディエンス",
        "audienceLikelyToGoShoppingTip": "今週買い物をする人々の確率を選択してください。 予測は暦週に基づいており、毎週の月曜日に更新されます。 確率が低い場合、オーディエンス規模が大きいですが、コンバージョンの可能性は低いです。 確率が高い場合、オーディエンス規模が小さいですが、肯定的に反応する可能性が高いです。",
        "brandSectionTitle": "どのブランドを予測に含めるべきですか？",
        "brandSectionTitleTip": "少なくとも1つのブランドを追加してください。",
        "selectedBrands": "オーディエンスがおそらく買い物する店：",
        "selectCompetitorsBrands": "競合他社のブランドを選択",
        "showBrandsInGroups": "ブランドをグループで表示する",
        "brandsInGroups": "ブランドをグループする",
        "yours": "御社の顧客",
        "competitors": "競合他社",
        "ownStoresTooltip": "購入客：店舗購入した人\n\n来店未購入者：入店したが購入しなかった人\n\nウィンドウショッパー：店の外で時間を過ごし、入店しなかった人",
        "selectLocationsHint": "オーディエンスを獲得する場所を選択してください",
        "downloadLocationsList": "ロケーションリストをダウンロードする",
        "selectCitiesHint": "オーディエンスを獲得するためには、ロケーションの地名を選択してください",
        "selectDurationHint": "オーディエンス獲得の期間を選択する",
        "selectDurationDesc": "期間中に少なくとも1回",
        "selectDurationTooltip": "たとえば、過去1ヶ月/ 3か月",
        "cosmoseAiRecommendationTurnOn": "Cosmose AIオン",
        "cosmoseAiRecommendationTurnOff": "Cosmose AIオフ",
        "cosmoseAiRecommendationTooltipLine1": "キャンペーンのプリセットはCosmose AIにより設定されています。",
        "cosmoseAiRecommendationTooltipLine2": "ゼロから設定する場合、下のスイッチを押してください。",
        "chooseBusinessCategories": "ビジネスカテゴリ",
        "businessCategories": "ビジネスカテゴリ",
        "other": "その他"
      },
      "media": {
        "platformBudgetTooLow": "このプラットフォームを使用するには、予算が少なくとも{{value}}である必要があります",
        "selectAllPlatforms": "すべてのプラットフォームを選択する",
        "deselectAllPlatforms": "すべてのプラットフォームの選択を解除する",
        "selectAllFormats": "すべてのフォーマットを選択する",
        "deselectAllFormats": "すべてのフォーマットの選択を解除する",
        "title": "メディア",
        "question": "どのメディアを使用しますか？",
        "splitBudget": "分割予算",
        "budgetSplitIncorrectly": "予算が誤って分割されています",
        "budgetTooLowOrUndefined": "予算が低すぎるか、定義されていません",
        "splitBudgetPerPlatform": "プラットフォームごとの予算分割",
        "addNewPlatform": "新しいプラットフォームを追加",
        "createNewAdSet": "新しい広告セットを作成",
        "platform": "プラットホーム",
        "format": "フォーマット",
        "description": "説明",
        "landingPageUrl": "ランディングページのURL",
        "choosePlatforms": "プラットフォームの選択",
        "chooseFormats": "フォーマットを選択する",
        "adSetSubcategories": {
          "OPEN_SCREEN": "画面を開く",
          "FEED_ADS": "広告のフィード",
          "REGULAR_BANNER": "通常のバナー",
          "FOCUS_PIC": "フォーカス写真"
        },
        "errors": {
          "landingPageUrl": "ランディングページのURLがないか正しくありません",
          "files": "ファイルは追加されませんでした",
          "description": "説明が必要です",
          "platform": "プラットフォームが必要です",
          "format": "フォーマットが必要です"
        },
        "categories": {
          "ONLINE_VIDEO": "オンラインビデオ",
          "SOCIAL_MEDIA": "SNS",
          "NEWS": "ニュース",
          "FITNESS": "フィットネス",
          "ENTERTAINMENT": "エンターテインメント",
          "PHOTO_TAKING_AND_BEAUTY": "写真撮影と美容",
          "MUSIC": "音楽",
          "LIFE_CONVENIENCE": "生活の利便性",
          "COOKING_GUIDE": "料理ガイド",
          "OTA": "OTA",
          "UTILITY": "ユーティリティ",
          "RECOMMENDED": "お勧め",
          "SPORTS": "スポーツ",
          "GOURMET": "グルメ",
          "TRAVEL": "旅行",
          "TOOLS": "道具",
          "MATERNITY": "マタニティ",
          "Facebook": "Facebook",
          "Instagram": "Instagram"
        },
        "downloads": "ダウンロード",
        "dailyUsers": "毎日のユーザー",
        "openScreen": "フルスクリーン広告",
        "focusPic": "焦点広告",
        "feedAds": "フィード広告",
        "regularBanner": "バナー広告"
      },
      "files": {
        "summary": {
          "header": "追加のキャンペーンファイル"
        }
      },
      "assets": {
        "name": "名前",
        "size": "サイズ",
        "description": "説明",
        "modified": "修正された",
        "addFiles": "ファイルを追加",
        "edit": "編集",
        "delete": "削除する",
        "cancel": "キャンセル",
        "save": "保存",
        "or": "または",
        "uploadYourAssets": "アセットをアップロードする",
        "uploadNewAssets": "新しいアセットをアップロードする",
        "noAssets": "このキャンペーンにはまだアセットがありません"
      },
      "selectAll": "すべて選択",
      "deselectAll": "すべての選択を解除",
      "TIER_1": "第1ティア",
      "TIER_2": "第2ティア",
      "backToDashboard": "ダッシュボードに戻る",
      "platformNameFIlter": {
        "searchAppByName": "名称でアプリを検索"
      },
      "platformListSelection": {
        "all": "すべて",
        "selected": "選択したもの",
        "notSelected": "選択されていないもの",
        "show": "表示項目"
      },
      "guidedTour": {
        "action": {
          "next": "次へ",
          "previous": "前",
          "exitDemo": "デモを終了"
        },
        "china": {
          "campaignListAddNewCampaign": {
            "description": "新しいキャンペーンを作成します。",
            "nextStepDescription": "次へ：[新しいキャンペーンの追加]をクリックする。"
          },
          "campaignObjectiveSelectLocalAudience": {
            "description": "キャンペーンは「ローカルオーディエンス」を\nターゲットにしています。\nローカルオーディエンスとは、日本に在住する人向けのキャンペーンを指します。"
          },
          "campaignObjectiveSelectNewStoreOpening": {
            "description": "キャンペーンの目的を選択します。例は「新規開拓」が選択されています。選択した項目に基づき、CosmoseAIがカスタムキャンペーンのプリセットを行います。",
            "nextStepDescription": "次へ：「新規開店」をクリックする。"
          },
          "plannerStartSelectAudience": {
            "description": "これがCosmoseウィザードです。 5つの簡単なステップで、キャンペーンの全体像を設定します。 オーディエンスの設定から始めましょう。",
            "nextStepDescription": "次へ：「ターゲットオーディエンスはどこで買い物をしますか？」をクリックします。"
          },
          "audienceShowEstimates": {
            "description": "推定オーディエンス数は、設定内容によって都度再計算され、こちらに表示されます。"
          },
          "audienceAskToHoverSegmentInfo": {
            "description": "オーディエンスセグメントを詳しく調べてください。",
            "nextStepDescription": "次へ：「i」アイコンにカーソルを合わせる。"
          },
          "audienceReadSegmentDescriptions": {
            "description": "オーディエンスセグメントの説明を読んでください。"
          },
          "audienceSelectCompetitors": {
            "description": "競合他社のブランドを選択します。",
            "nextStepDescription": "次へ：「Yves Saint Laurent」を選択する。"
          },
          "audienceShowEstimatesChange": {
            "description": "推定オーディエンス数の増減が確認できます。"
          },
          "audienceSelectLocationCategories": {
            "description": "ターゲットグループに適したカテゴリーを選択します。",
            "nextStepDescription": "次へ：「アートギャラリー」を選択する。"
          },
          "audienceExplainAddingLocationCategories": {
            "description": "カテゴリを追加することによって、オーディエンス数を増やすことが出来ます。"
          },
          "audienceAskToSelectCity": {
            "description": "ターゲティングエリアを選択します。",
            "nextStepDescription": "次へ：「上海」を選択する。"
          },
          "audienceShowTimespan": {
            "description": "ターゲティングオーディエンスの対象期間を設定します。"
          },
          "audienceAskToClickContinue": {
            "description": "次のステップに進みます。",
            "nextStepDescription": "次へ：[続行]をクリックする。"
          },
          "demographicsSelectGender": {
            "description": "ターゲットオーディエンスの性別を選択します。",
            "nextStepDescription": "次へ：「女性」を選択する。"
          },
          "demographicsAskToClickContinue": {
            "description": "次のステップに進みます。",
            "nextStepDescription": "次へ：「続行」をクリックする。"
          },
          "budgetSelectCampaignDuration": {
            "description": "キャンペーン期間を定義することができます。"
          },
          "budgetCalculationExplanation": {
            "description": "予算は設定された期間、広告接触頻度およびリーチ率に基づき計算されます。"
          },
          "budgetAskToClickContinue": {
            "description": "次のステップに進みます。",
            "nextStepDescription": "次へ：「続行」をクリックする。"
          },
          "mediaSearchPlatform": {
            "description": "プラットフォームを名前で検索できます",
            "nextStepDescription": "次へ：「Zaker」を選択してください。"
          },
          "mediaSelectFormat": {
            "description": "最適なフォーマットを設定できます。",
            "nextStepDescription": "次へ：「画面を開く」を選択する。"
          },
          "mediaAskToClickContinue": {
            "description": "次のステップに進みます。",
            "nextStepDescription": "次へ：「続行」をクリックする。"
          },
          "spotplanAnalyze": {
            "description": "キャンペーンのスポットプランを解析する。"
          },
          "spotplanAskToClickSummary": {
            "description": "いいね。",
            "nextStepDescription": "次へ：「概要」をクリックする。"
          },
          "summaryAskToClickSendForReview": {
            "description": "設定情報を最終確認すると、レビューのためにキャンペーンを送信することができます。",
            "nextStepDescription": "次へ：「レビューのために送信」をクリックする。"
          },
          "sentForReviewAskToClickBackToDashboard": {
            "description": "このキャンペーンはデモです。 実際は、レビューのためにキャンペーンプランを送信すると、Cosmoseのアカウントマネージャーが4営業時間以内に メールで連絡します。",
            "nextStepDescription": "次へ：「ダッシュボードに戻る」をクリックする。"
          },
          "campaignListExposeCampaign": {
            "description": "ダッシュボードからキャンペーンにアクセスすることが できます。"
          }
        },
        "japan": {
          "audienceSelectCompetitors": {
            "description": "競合他社のブランドを選択します。",
            "nextStepDescription": "次へ：「競合他社」を選択する。"
          },
          "audienceAskToSelectCity": {
            "description": "オーディエンスを獲得したい都市を選択してください。",
            "nextStepDescription": "次へ：「東京」を選択する。"
          },
          "mediaSearchPlatform": {
            "description": "プラットフォームを名前で検索できます",
            "nextStepDescription": "次へ：「Video」を入力してください。"
          },
          "mediaSelectFormat": {
            "description": "最適なフォーマットを設定できます。",
            "nextStepDescription": "次へ：「Video」を選択する。"
          },
          "budgetAskToClickSummary": {
            "description": "次のステップに進みます。",
            "nextStepDescription": "次へ：「概要」をクリックする。"
          },
          "audienceAnalyzeLocationCategories": {
            "description": "推奨されたビジネスカテゴリを分析してください。"
          },
          "audienceClickEditLocationCategories": {
            "nextStepDescription": "「編集」をクリックする",
            "description": "「編集」を選択して、リスト全体をプレビューします。"
          },
          "audienceSelectLocationCategories": {
            "description": "ターゲットグループに適したカテゴリーを選択します。",
            "nextStepDescription": "次へ：「アートギャラリー」を選択する。"
          },
          "audienceCloseLocationCategoriesDialog": {
            "description": "選択したカテゴリーを保存する。",
            "nextStepDescription": "「保存」をクリックしてください。"
          },
          "audienceExpandCategory": {
            "description": "カテゴリを拡大する",
            "nextStepDescription": "次へ：矢印をクリックする"
          },
          "mediaExpandPlatform": {
            "description": "プラットフォームの名前をクリックして、メディアプラットフォームの広告フォーマットを展開します"
          }
        },
        "startDemoModal": {
          "welcome": "ようこそ、",
          "introduction": "Cosmose Mediaのサービスをご利用いただき、ありがとうございます。\nこちらに本サービスの最も重要な機能を紹介する、短いデモを用意しています。",
          "timespan": "約5分かかります。",
          "startDemo": "デモを開始"
        }
      },
      "platformNameFilter": {
        "searchAppByName": "名称でアプリを検索"
      }
    },
    "error": {
      "403": {
        "title": "禁止されたエラー"
      },
      "404": {
        "title": "ページが見つかりません"
      },
      "500": {
        "title": "内部サーバーエラー"
      }
    },
    "execution": {
      "comments": "コメント",
      "uploadNewDocument": "新しいドキュメントをアップロードする",
      "modal": {
        "areYouSure": "このアイテムを「{{to}}」",
        "thisItem": "してもよろしいですか？",
        "mandatoryField": "このフィールドは必須です",
        "addComment": "コメントを追加",
        "approve": "承認",
        "reject": "拒否",
        "sendForReview": "レビューのために送信",
        "file": "ファイル",
        "wouldYouLikeToSendThisFileForReview": "このファイルをレビュー用に送信しますか？"
      },
      "sendForReviewModal": {
        "legalVerification": "法的文書を提出していただきありがとうございます。3営業日以内にメディアプラットフォームで確認し、ご連絡いたします。",
        "creativeVerification": "クリエイティブを送信していただき、ありがとうございます。3営業日以内にメディアプラットフォームでレビューを行い、ご連絡いたします。",
        "trackingCodes": "トラッキングコードを送信していただき、ありがとうございます。2営業日以内にメディアプラットフォームで確認し、ご連絡いたします。"
      },
      "assetPackageLabels": {
        "BUSINESS_LICENSE": {
          "title": "ビジネスライセンス",
          "subtitle": "必須フィールド"
        },
        "ICP_CERTIFICATION": {
          "title": "ICP認証",
          "subtitle": "URLアドレスが.cnで終わる場合"
        },
        "PORTRAIT_RIGHT_DISCLAIMER": {
          "title": "クリエイティブに有名人/モデルの写真が含まれている場合、",
          "subtitle": "肖像権に関する免責事項。"
        },
        "CREATIVES": {
          "title": "クリエイティブ",
          "subtitle": ""
        },
        "AD_PREVIEW": {
          "title": "広告プレビュー",
          "subtitle": ""
        },
        "TRACKING_CODES": {
          "title": "トラッキングコードの設定",
          "subtitle": "",
          "SIZMEK_TRACKING_CODE": "Sizmek",
          "MIAOZHEM_SYSTEMS_TRACKING_CODE": "Miaozhemシステム",
          "DOUBLECLICK_TRACKING_CODE": "ダブルクリック",
          "AD_MASTER_TRACKING_CODE": "広告マスター"
        },
        "SIZMEK_TRACKING_CODE": {
          "title": "Sizmek",
          "subtitle": ""
        },
        "MIAOZHEM_SYSTEMS_TRACKING_CODE": {
          "title": "Miaozhemシステム",
          "subtitle": ""
        },
        "DOUBLECLICK_TRACKING_CODE": {
          "title": "ダブルクリック",
          "subtitle": ""
        },
        "AD_MASTER_TRACKING_CODE": {
          "title": "広告マスター",
          "subtitle": ""
        }
      },
      "legal-censorship": {
        "title": "法的検証",
        "headerTitle": "法的検証",
        "uploadDocuments": "確認のためにドキュメントをアップロードする",
        "onceYouClick": "「レビューのために送信」ボタンを押すと、送信の変更はできません。 提出物は現在のステップにのみ適用されます。",
        "businessLicence": "ビジネスライセンス",
        "icpCertification": "ICP認証",
        "portraitRightDisclaimer": "肖像権の免責事項",
        "mandatoryField": "必須フィールド",
        "endsWith": "URLアドレスが.cnで終わる場合",
        "ifCreative": "クリエイティブに有名人/モデルの写真が含まれている場合",
        "IN_REVIEW": "文書が送信され、承認を待っています",
        "notUploadedYet": "法的文書はまだアップロードされていません"
      },
      "creative-censorship": {
        "title": "クリエイティブの検証",
        "headerTitle": "クリエイティブの検証",
        "uploadCreatives": "確認のためにクリエイティブをアップロードする",
        "tooltip": "このプロセスには少なくとも3営業日かかります。 \n期限までにクリエイティブをアップロードしてください。",
        "notUploadedYet": "クリエイティブはまだアップロードされていません"
      },
      "tracking-codes": {
        "title": "トラッキングコード",
        "headerTitle": "トラッキングコードの設定",
        "pageUrl": "ランディングページのURL",
        "chooseTrackingCodes": "アップロードするトラッキングコードの選択",
        "uploadTrackingCodes": "トラッキングコードをアップロードする",
        "notUploadedYet": "追跡コードはまだアップロードされていません"
      },
      "ad-preview": {
        "title": "広告のプレビュー",
        "headerTitle": "広告プレビューの確認",
        "uploadAdPreview": "広告プレビューをアップロードする",
        "dpsHasNotYet": "DSPは「広告プレビュー」をまだアップロードしていません。",
        "letYouKnow": "「広告のプレビュー」が確認できるようになりましたら、メールでお知らせします。"
      },
      "asset-package-status": {
        "IN_REVIEW": "レビュー中",
        "APPROVED": "承認されました",
        "REJECTED": "拒否されました"
      },
      "status": {
        "IN_REVIEW": "文書が送信され、承認を待っています",
        "APPROVED": "すべての文書が承認されました",
        "REJECTED": "すべての文書が拒否されました"
      },
      "mobile": {
        "executionPhase": "実行フェーズ",
        "useDesktopVersion": "このステップをプレビューするには、デスクトップバージョンを使用してください"
      }
    }
  },
  "dynamicControls": {
    "image_title": {
      "placeholder": "テキスト",
      "tip": ""
    },
    "link_description": {
      "placeholder": "ニュースフィードリンクの説明",
      "tip": ""
    },
    "link_url": {
      "placeholder": "ウェブサイトのURL",
      "tip": ""
    },
    "visible_link_url": {
      "placeholder": "リンクの表示",
      "tip": ""
    },
    "fb_page_id": {
      "placeholder": "Facebookページの選択",
      "tip": ""
    },
    "instagram_account_id": {
      "placeholder": "Facebookページの選択",
      "tip": ""
    }
  },
  "platform": {
    "Facebook": "Facebook",
    "Instagram": "Instagram",
    "Wechat": "Wechat",
    "Moweather": "Moweather",
    "Weibo": "Weibo",
    "MangoTV": "Mango TV"
  },
  "label": {
    "comments": "コメント",
    "audienceEstimation": "オーディエンス規模の推定",
    "avgFrequency": "広告接触頻度",
    "clearAll": "すべてをクリア",
    "selectAll": "すべて選択",
    "allBrandsSelected": "選択したすべてのブランド",
    "brandsSelected": "選択されたブランド",
    "budget": "予算",
    "deletePostSuccess": "投稿は正常に削除されました！",
    "congratulations": "おめでとう！",
    "status": "状態",
    "expectedStatus": "期待された",
    "showInfo": "情報の表示",
    "hideInfo": "情報を隠す",
    "hide": "隠す",
    "online": "オンライン",
    "offline": "オフライン",
    "campaigns": "キャンペーン",
    "username": "ユーザー名",
    "emailAddress": "メールアドレス",
    "password": "パスワード",
    "newPassword": "新しいパスワード",
    "repeatPassword": "パスワードを再度入力してください",
    "currentPassword": "現在のパスワード",
    "name": "名前",
    "enterLinkHere": "ここにリンクを入力してください",
    "price": "価格",
    "findPostId": "投稿IDを見つけ",
    "priceTip": "キャンペーンの価格を選択してください。",
    "type": "キャンペーンの種類",
    "typeTip": "少なくとも1つのキャンペーンタイプを選択してください。",
    "frequencyCapping": "フリークエンシーのキャップ",
    "frequencyCappingTip": "キャンペーンの頻度を選択。",
    "perClick": "クリックごと",
    "timesPer": "時間ごと",
    "perUser": "ユーザーごと",
    "addImage": "画像を追加",
    "description": "説明",
    "addNew": "新しいキャンペーンの追加",
    "campaignName": "キャンペーン名",
    "actions": "行動",
    "format": "フォーマット",
    "gender": "性別",
    "age": "年齢",
    "timeSpan": "期間",
    "theMostPopular": "最もポピュラーな",
    "other": "その他",
    "customBudget": "カスタム予算",
    "budgetSpent": "使われた予算",
    "budgetOf": "内",
    "daysLeft": "残った",
    "currency": "通貨",
    "campaignDuration": "キャンペーン期間",
    "selectDuration": "期間を選択",
    "durationData": "期間",
    "dateRange": "期間",
    "customGroups": "カスタムグループ",
    "competitors": "競合他社",
    "brandOwnStores": "ターゲット顧客",
    "storeVisitors": "オーディエンス規模の推定",
    "fillCorectData": "すべてのフィールドに正しいデータを入力してください。",
    "allFieldsAreMandatory": "すべてのフィールドは必須です",
    "filter": "フィルタ",
    "perViewer": "一人当たり",
    "lessLikely": "可能性が低い",
    "veryLikely": "可能性が高い",
    "predictedVisitors": "予測来店者",
    "utcTime": "UTC時間",
    "localTime": "現地時間",
    "createManually": "手動で作成する",
    "predictedAudience": "予測オーディエンス",
    "relevantLocationCategories": "場所のカテゴリ",
    "recommendedImageSpecs": "推奨画像仕様",
    "selectBrands": "ブランドを選択",
    "start": "開始",
    "cities": "都市",
    "reach": "リーチ率",
    "totalCampaignBudget": "キャンペーンの総予算",
    "myBudget": "私の予算",
    "campaignEnded": "キャンペーン終了",
    "editMedia": "メディアの編集",
    "preview": "プレビュー",
    "visitsPeriod": "来店期間",
    "technicalSpec": "技術仕様",
    "mediaSpotPlan": "メディアスポットプラン",
    "success": "成功",
    "storeTypes": {
      "ALL": "すべて",
      "JUST_LOOKING": "来店未購入者",
      "WINDOW_SHOPPERS": "ウィンドウショッパー",
      "OWN": "自分の",
      "YOUR_CUSTOMERS": "購入客",
      "COMPETITORS": "競合他社",
      "CUSTOM": "カスタム"
    },
    "visitPeriodTypes": {
      "WEEK": "週",
      "MONTH": "月",
      "QUARTER": "四半期",
      "HALFYEAR": "半年",
      "YEAR": "年"
    },
    "currencies": {
      "HKD": "HKD",
      "USD": "USD",
      "CNY": "CNY",
      "EUR": "EUR",
      "JPY": "JPY"
    },
    "currenciesSymbol": {
      "HKD": "HK$",
      "USD": "$",
      "CNY": "¥",
      "EUR": "€",
      "JPY": "¥"
    },
    "billingPeriodType": {
      "DAILY": "毎日",
      "WEEKLY": "毎週",
      "MONTHLY": "毎月",
      "LIFETIME": "一生"
    },
    "adSetType": {
      "CPM": "CPM",
      "CPC": "CPC"
    },
    "frequency": {
      "week": "週",
      "month": "月",
      "quarter": "四半期"
    },
    "durations": {
      "days": "日々",
      "weeks": "週間"
    },
    "genderType": {
      "ALL": "すべて",
      "MALE": "男性",
      "FEMALE": "女性"
    },
    "statuses": {
      "ALL": "すべて",
      "DRAFT": "ドラフト",
      "PUBLISHED": "公開",
      "PENDING": "保留中",
      "FAILED": "失敗",
      "PAUSED": "一時停止",
      "IN_REVIEW": "レビュー中",
      "PLANNING": "計画中",
      "PLANNING_REVIEW": "計画レビュー",
      "FINISHED": "終了",
      "EXECUTION": "実施"
    },
    "displayStatuses": {
      "resuming": "再開中",
      "pausing": "一時停止する"
    }
  },
  "popup": {
    "confirmation": "確認",
    "cancelTitle": "変更内容を保存",
    "cancelText": "キャンセルしてもよろしいですか？",
    "cancelKeepDraftSuccess": "キャンペーンは下書きとして保存されました",
    "pauseCampaignTitle": "キャンペーンを一時停止",
    "pauseCampaignText": "このキャンペーンを一時停止してもよろしいですか？",
    "popupCampaignName": {
      "addNew": "キャンペーン名を追加",
      "edit": "名前を編集",
      "campaignName": "キャンペーン名",
      "charactersLimit": "最大36文字"
    }
  },
  "button": {
    "login": "ログイン",
    "logout": "ログアウト",
    "create": "作成",
    "changeAudience": "オーディエンスを変える",
    "resetPassword": "パスワードを再設定する",
    "cancel": "キャンセル",
    "continue": "続行",
    "save": "保存",
    "ok": "OK",
    "sendForReview": "レビューのために送信",
    "nextStep": "次のステップ",
    "previousStep": "一つ前のステップ",
    "confirm": "承認する",
    "summary": "概要",
    "addNewPlatform": "新しいプラットフォームの追加",
    "addNewCampaign": "新しいキャンペーンの追加",
    "pauseCampaign": "キャンペーンを一時停止する",
    "pauseCampaignConfirm": "はい、一時停止します",
    "resume": "再開する",
    "delete": "削除",
    "deletePost": "ポストを削除",
    "publish": "公開",
    "edit": "編集",
    "show": "表示",
    "back": "戻る",
    "showSummary": "概要を表示",
    "showReport": "レポートを表示",
    "showAll": "すべてを表示",
    "showLess": "表示を減らす",
    "report": "レポート",
    "dashboard": "ダッシュボードに進む",
    "backToDashboard": "ダッシュボードに戻る",
    "deleteCampaign": "キャンペーンを削除",
    "keepDraft": "ドラフトを保持",
    "remove": "削除",
    "addYourFile": "ファイルを追加",
    "addTrackingCodes": "トラッキングコードを追加",
    "approve": "承認する",
    "reject": "拒否する",
    "campaignSummary": "キャンペーンの概要",
    "downloadRequirements": "要件をダウンロードする",
    "downloadSpotplan": "スポットプランをダウンロードする",
    "previous": "前",
    "goToExecution": "実行に移動",
    "downloadCampaignProposal": "キャンペーン提案をダウンロードする"
  },
  "tip": {
    "recommendedImageSize": "推奨画像サイズ：{{width}} x {{height}}ピクセル",
    "minImageSize": "最小画像サイズ：{{minWidth}} x {{minHeight}}ピクセル",
    "maxImageSize": "最大画像サイズ：{{maxWidth}} x {{maxHeight}}ピクセル",
    "minAspectRatio": "最小アスペクト比：{{imageRatio}}",
    "recommendedAspectRatio": "推奨アスペクト比：{{imageRatio}}",
    "maxAspectRatio": "最大アスペクト比：{{imageRatio}}",
    "recommendedImageInfo": "広告配信を最大化するには、オーバーレイテキストをほとんどまたはまったく含まない画像を使用します。",
    "recommendedExtensions": "これらのフォーマットでファイルをアップロードしてください："
  },
  "error": {
    "imageUploader": {
      "dimensionsAndRatio": "無効なサイズとアスペクト比。",
      "dimensions": "無効なサイズ。",
      "ratio": "無効なアスペクト比。",
      "ratioNotSameAsRecommended": "アスペクト比は有効ですが、推奨とは異なります。",
      "format": "無効なファイル形式。"
    },
    "tooSmallEstimation": "推定されるオーディエンス規模が小さすぎます。より良い結果を得るためにグループを追加してください。",
    "email": "有効なメールアドレスを入力してください",
    "required": "フィールドは必須項目です",
    "minlength": "値が短すぎます",
    "maxlength": "値が長すぎます",
    "min": "値が小さすぎます",
    "max": "値が大きすぎます",
    "pattern": "無効なフォーマット",
    "repeatNotSame": "パスワードが一致しません",
    "mustContainOneDigitAndOneUppercaseLetter": "少なくとも1つの数字と1つの大文字を含める必要があります",
    "status403": "サーバーへのアクセスは禁止されています。 後でもう一度お試しください。",
    "status400": "送信するデータを確認して、しばらくしてからもう一度お試しください。",
    "status500": "不明なサーバー側の例外が発生しました。 後でもう一度やり直してください。",
    "default": "エラーが発生しました。",
    "campaignFulfillError": "キャンペーンをスケジュールするには、フォームに入力する必要があります。",
    "selectAudienceGroups": "キャンペーンの対象ユーザーのグループを選択していません。 少なくとも1つを選択してください。",
    "selectVisitPeriod": "オフラインストアへの来店期間を設定していません。 オーディエンスが来店する頻度を指定してください。",
    "selectBrands": "ブランドを選択してください。",
    "selectDemographics": "希望するユーザー属性を選択してください。",
    "selectTimeline": "キャンペーン期間の日付を選択してください。",
    "pastTimeline": "キャンペーンは過去にスケジュールされています。 タイムラインを変更してください。",
    "budgetTimeSpan": "キャンペーン予算の期間を選択してください。",
    "budgetNoSet": "予算をゼロにすることはできません。 適切な予算額を選択してください。",
    "minimalBudget": "予算は少なくとも X である必要があります。資金をさらに割り当ててください。",
    "budgetPaymentMethod": "プラットフォームは、支払いエラーに対するキャンペーンの予算を割り当てることができませんでした。 お支払い方法の設定を確認してください。",
    "budgetCurrency": "アカウントに通貨が設定されていません。",
    "selectPlatform": "キャンペーンのプラットフォームを選択してください。",
    "campaignName": "キャンペーンの名前を設定してください。",
    "unknownConnectionError": "不明な接続エラーが発生しました。",
    "statsUpload": "統計をアップロードできませんでした。"
  },
  "budgetDetails": {
    "netMedia": "媒体側の正味価格",
    "dataFee": "データ料金",
    "accountingFee": "会計料金",
    "tax": "税金",
    "budgetDetails": "予算の詳細"
  },
  "profile": {
    "logout": "ログアウト",
    "help": "ヘルプ",
    "settings": {
      "settings": "設定",
      "twoStepVerification": "2段階認証",
      "enableTwoStepVerification": "2段階認証を有効にする",
      "disableTwoStepVerification": "2段階認証を無効にする",
      "on": "オン",
      "off": "オフ",
      "authenticatorApp": "認証システムアプリ",
      "authenticatorAppDescription": "認証システムアプリを使用して、無料の確認コードを取得",
      "setup": "セットアップ",
      "downloadApp": "認証システムアプリをダウンロードする",
      "downloadAuthenticatorApp": "Google認証システムアプリ（または時間限定のワンタイムパスワードをサポートするその他のアプリ）をダウンロードする",
      "enterOtp": "ワンタイムパスワードを入力する",
      "firstOtp": "最初のワンタイムパスワードを入力する",
      "secondOtp": "2番目のワンタイムパスワードを入力する",
      "confirmEnable2faMessage": "「保存してログアウト」をクリックすると、ログアウトした後でもう一度ログインするには、2段階認証が必要になります。",
      "confirmDisable2faMessage": "「保存してログアウト」をクリックするとログアウトした後で2段階認証が無効になります。",
      "confirm": "承認する",
      "saveAndLogout": "保存してログアウト",
      "verify": "承認",
      "next": "次へ"
    }
  },
  "guidedTour": {
    "stepPagination": "{{currentStepNumber}} / {{numberOfSteps}}"
  },
  "validationErrors": {
    "required": "必須",
    "invalidCode": "無効なコード"
  },
  "clients": {
    "clients": "顧客",
    "invalidName": "無効な名前",
    "clientName": "顧客名",
    "addNewClient": "新しい顧客を追加する",
    "details": "詳細",
    "createNewClient": "新しい顧客のアカウント作成",
    "clientDetails": "顧客の詳細",
    "category": "カテゴリー",
    "companyName": "会社名",
    "companyAddress": "会社の住所",
    "currency": "通貨",
    "country": "国名",
    "timezone": "タイムゾーン",
    "brandsOwnStores": "ブランド / 自社ブランド店",
    "addAnother": "その他を追加する",
    "addTeamMember": "チームメムバーを追加する",
    "clientCreated": "顧客のアカウントが無事に作成されました",
    "inviteTeammates": "チームメムバーを参加させる",
    "backToList": "リストに戻る",
    "sendInvite": "招待状を送る",
    "goBack": "戻る",
    "createSuccessDialog": {
      "clientCreated": "顧客のアカウントが無事に作成されました",
      "inviteTeammates": "チームメムバーを参加させる",
      "addTeammates": "チームメムバーを追加する",
      "planCampaign": "キャンペーンを企画する"
    },
    "teamMembersDialog": {
      "inviteNewMembers": "新しいメムバーを追加する",
      "invitedMembers": "招待されたメムバー",
      "addTeamMembers": "{{clientName}}のためにチームメムバーを追加する",
      "typeEmailAddress": "メールアドレスを入力する",
      "sendInvite": "招待状を送る",
      "removeUser": "ユーザを削除する",
      "noUsers": "この顧客には誰も追加されていません",
      "invitationSent": "招待状の送信が完了しました",
      "openInvitedMembers": "リストを管理するために「招待されたメムバー」を開く"
    },
    "roles": {
      "none": "不在",
      "mediaPlanner": "メディアプランナー",
      "accountManager": "アカウントマネージャー"
    },
    "typeClientName": "Type client's name"
  },
  "clientInvitation": {
    "invalidToken": "無効なトークン",
    "welcome": "Cosmose Mediaへ",
    "toCosmose": "ようこそ。",
    "setup": "アカウントを設定しましょう。 それは、約1分かかります。",
    "getStarted": "始めましょう",
    "setupProfile": "プロファイルを設定しましょう。",
    "signedUpWith": "メールで登録されます。",
    "passwordRequirerments": {
      "passwordRequirerments": "パスワードの要件",
      "mustContain": "パスワードは、",
      "digit": "少なくとも1つの数字、",
      "lowerCaseLetter": "1つの小文字、",
      "upperCaseLetter": "1つの大文字を含める必要があります。",
      "minLength": "12文字以上"
    },
    "wrongAccount": "アカウントが間違っていますか？",
    "instead": "代わりに",
    "passwordsDoNotMatch": "パスワードが一致していません。",
    "serverErrorMessage": "ごめんなさい！問題が発生しました。しばらくしてからもう一度お試しください。問題が解決しない場合は、フィードバックをお寄せください。"
  },
  "pushNotifications": {
    "Notification name": "Notification name",
    "Cities": "Cities",
    "Shopping malls": "Shopping malls",
    "Brands": "Brands",
    "Timeline": "Timeline",
    "Status": "Status",
    "Notifications": "Notifications",
    "Search by name": "Search by name",
    "Create notification": "Create notification",
    "Create new notification": "Create new notification",
    "Leave setup": "Leave setup",
    "Edit": "Edit",
    "Select locations to capture audience": "Select locations to capture audience",
    "Next": "Next",
    "Back": "Back",
    "Type city name e.g. Kuala Lumpur": "Type city name e.g. Kuala Lumpur",
    "Type shopping mall name": "Type shopping mall name",
    "Select start date": "Select start date",
    "Select end date": "Select end date",
    "Campaign timeline": "Campaign timeline",
    "Notifications setup summary": "Notifications setup summary",
    "Campaign name": "Campaign name",
    "Start": "Start",
    "End": "End",
    "Delete": "Delete",
    "Start campaign": "Start campaign",
    "Edit notification name": "Edit notification name",
    "Type brand name e.g. Kuala Lumpur": "Type brand name e.g. Kuala Lumpur",
    "Type brand name": "Type brand name",
    "DRAFT": "Draft",
    "ON_AIR": "On air",
    "SCHEDULED": "Scheduled",
    "ALL": "All",
    "FINISHED": "Finished",
    "Hurray!": "Hurray!",
    "Your notifications campaign \"{{campaignName}}\" is going to start soon": "Your notifications campaign \"{{campaignName}}\" is going to start soon",
    "Back to dashboard": "Back to dashboard",
    "Create new campaign": "Create new campaign",
    "Client": "Client",
    "Start date must be before end date": "Start date must be before end date",
    "Notification update failed": "Notification update failed",
    "Notification create failed": "Notification create failed",
    "Notification delete failed": "Notification delete failed",
    "Notification deleted": "Notification deleted",
    "+ {{value}} more": "+ {{value}} more",
    "Stop campaign": "Stop campaign",
    "No": "No",
    "Yes": "Yes",
    "Please confirm stopping the campaign": "Please confirm stopping the campaign",
    "Please confirm deleting the campaign": "Please confirm deleting the campaign",
    "Notification updated": "Notification updated",
    "Notification name update failed": "Notification name update failed",
    "Notification start failed": "",
    "Type city name e": {
      "g": {
        " Kuala Lumpur": "Type city name e.g. Kuala Lumpur"
      }
    }
  },
  "mainHeader": {
    "Content audit": "コンテンツ監査",
    "Media campaigns": "メディアキャンペーン",
    "Notifications": "通知",
    "Global search": "グローバル検索",
    "Lockscreen campaigns": "ロック画面キャンペーン"
  },
  "HONOR_LAYOUT": {
    "SECTIONS": {
      "AUDIT": "監査",
      "REPORTS": "レポート",
      "SETTINGS": "設定"
    },
    "ITEMS": {
      "CONTENT_AUDIT": "コンテンツ監査",
      "REJECTION_REASONS": "却下理由",
      "WORKLOAD": "作業量",
      "CONTENT": "コンテンツ",
      "AUDIT_RATE": "監査率",
      "MANAGE_ACCESS": "アクセス管理"
    }
  },
  "FILTERS": {
    "FIELD": {
      "AUDITORS": "監査員",
      "HONOR_CATEGORY": "カテゴリー",
      "HONOR_LANGUAGE": "言語",
      "REJECTION_REASONS": "却下理由"
    },
    "NONE": "なし",
    "GLOBAL": "グローバル",
    "OPTIONS": {
      "ALL": "すべて"
    }
  },
  "2FA Code": "",
  "2FA Code is required": "",
  "Address": "",
  "All": "",
  "Almost there!": "",
  "An unexpected error occurred": "",
  "Application error occurred": "",
  "Are you sure?": "",
  "Budget amount update failed": "",
  "Budget data fee update failed": "",
  "Budget percentage split update failed": "",
  "Budget reach update failed": "",
  "Budget reset failed": "",
  "Budget view frequency update failed": "",
  "Campaign delete failed": "",
  "Campaign name update failed": "",
  "Campaign publish failed": "",
  "Campaign stages update failed": "",
  "Campaign timeline update failed": "",
  "Campaign update failed": "",
  "Change password": "",
  "Choose a client": "",
  "Client has been created!": "",
  "Client has been updated!": "",
  "Code must contains 6 characters": "",
  "Details": "",
  "Drag and drop a file to upload": "",
  "Email": "",
  "Email address": "",
  "Email address required": "",
  "Email incorrect!": "",
  "Email is required": "",
  "Email required!": "",
  "Empty list": "",
  "Error": "",
  "Error occured": "",
  "Error occurred": "",
  "Error occurred while saving campaign": "",
  "Error occurred!": "",
  "Forgot your password?": "",
  "GLOBAL_SEARCH": {
    "LIST": {
      "HEADER": "グローバル検索"
    }
  },
  "Incorrect email address": "",
  "CONTENT_AUDIT": {
    "LIST": {
      "HEADER": "コンテンツ監査"
    },
    "AUTO_AUDIT": {
      "RESULTS": {
        "ACCEPT": "承認",
        "DUBIOUS": "疑わしい",
        "VALIDATE": "検証",
        "REJECT": "拒否",
        "UNKNOWN": "不明"
      }
    }
  },
  "LOCKSCREEN": {
    "COPIED_TO_CLIPBOARD": {
      "CLOSE": "閉じる",
      "LABEL": "クリップボードにコピーしました！"
    },
    "DETAILS": {
      "BUTTONS": {
        "CANCEL": "キャンセル",
        "CONFIRM": "確認",
        "REJECT": "拒否",
        "REJECTION_REASON": "拒否理由",
        "APPROVE": "承認",
        "WITHDRAW": "取り下げ",
        "RESUME": "再開",
        "RE_AUDIT": "再審査",
        "PUBLISH": "公開"
      },
      "DIALOGS": {
        "REJECT": {
          "DESCRIPTION": "説明",
          "INFO": "キャンペーンの拒否理由を選択してください",
          "REASON": "理由",
          "REJECTION_CUSTOM_REASON": "拒否理由",
          "REJECTION_DESCRIPTION": "拒否の説明",
          "REJECTION_REASON": "拒否理由",
          "SELECT_REJECTION_REASON": "理由を選択",
          "TITLE": "よろしいですか？",
          "TOOLTIP": "拒否理由をご記入ください"
        }
      },
      "EMPTY": {
        "DESCRIPTION": "後でもう一度お試しください！",
        "TITLE": "データなし"
      },
      "ERROR": {
        "DESCRIPTION": "後でもう一度お試しください！",
        "SNACKBAR_TEXT": "予期しないエラーが発生しました。",
        "TITLE": "予期しないエラーが発生しました。"
      },
      "INFO": "下にスクロールしてロック画面キャンペーンの詳細をご確認ください",
      "LABELS": {
        "AUDIENCE": "オーディエンス",
        "CAMPAIGN_NAME": "キャンペーン名",
        "CATEGORY": "カテゴリ",
        "CONTENT": "コンテンツ",
        "COPYRIGHT": "著作権",
        "COUNTRIES": "市場",
        "CTA": "CTA",
        "DESCRIPTION": "説明",
        "DURATION": "期間",
        "DURATION_IN_DAYS": "期間（日数）",
        "IMAGE_PROVIDER": "画像プロバイダー",
        "LANDING_PAGE_URL": "ランディングページURL",
        "LANGUAGE": "言語",
        "NAME": "名前",
        "PUBLICATION": "公開",
        "PUBLISHER": "出版社",
        "START_DATE": "開始日",
        "TAGS": "タグ",
        "TARGET_LANGUAGES": "対象言語",
        "TITLE": "タイトル",
        "TYPE": "タイプ",
        "AUTO_AUDIT_TIME": "自動監査時間",
        "HUMAN_AUDIT_TIME": "人間監査時間",
        "ID": "ID",
        "IMAGE": "画像",
        "IMAGE_PREVIEW": "画像プレビュー",
        "LINK": "リンク",
        "MARKET": "市場",
        "PREVIEW": "プレビュー",
        "PREVIEW_ALL": "すべてプレビュー",
        "REAL_PHONE": "実機",
        "REAL_PHONE_PREVIEW": "実機プレビュー",
        "REVIEW_LOCK_SCREEN_RESOURCE": "ロック画面リソースの確認",
        "SAFE_ZONE": "セーフゾーン",
        "SAFE_ZONE_PREVIEW": "セーフゾーンプレビュー",
        "URL": "URL",
        "REVIEWING": "{{current}} / {{total}} を確認中",
        "PREVIOUS": "前へ",
        "NEXT": "次へ"
      },
      "STATUS_UPDATED": {
        "TITLE": "キャンペーンのステータスが変更されました。"
      },
      "TABS": {
        "AUDIENCE": "オーディエンス",
        "CONTENT": "コンテンツ",
        "DURATION": "期間",
        "PUBLISHER": "出版社"
      }
    },
    "FILTERS": {
      "ADVERTISER": {
        "OPTIONS": {
          "ALL": "すべて"
        }
      },
      "CATEGORY": {
        "OPTIONS": {
          "ALL": "すべて"
        }
      },
      "LANGUAGE": {
        "OPTIONS": {
          "ALL": "すべて",
          "ENGLISH": "英語",
          "INDONESIAN": "インドネシア語",
          "MALAY": "マレー語",
          "THAI": "タイ語",
          "VIETNAMESE": "ベトナム語",
          "FRENCH": "フランス語",
          "SPANISH": "スペイン語"
        }
      },
      "RESOURCE_TYPE": {
        "OPTIONS": {
          "ALL": "すべて",
          "CAMPAIGN": "キャンペーン",
          "CONTENT": "コンテンツ",
          "REPORTS": "レポート"
        }
      }
    },
    "LIST": {
      "BUTTONS": {
        "OPEN_DETAILS": "詳細"
      },
      "COLUMNS": {
        "AUDIT": {
          "PASS": "合格",
          "DUBIOUS": "疑わしい",
          "FAIL": "不合格",
          "TITLE": {
            "LABEL": "タイトル"
          },
          "DESCRIPTION": {
            "LABEL": "説明"
          },
          "IMAGE": {
            "LABEL": "画像"
          },
          "H5": {
            "LABEL": "H5"
          }
        },
        "AUDITOR": {
          "LABEL": "監査員"
        },
        "AUTO_AUDIT_RESULT": {
          "LABEL": "自動監査結果"
        },
        "AUTO_AUDIT_TIME": {
          "LABEL": "自動監査時間"
        },
        "AVG_TIME_ARTICLE": {
          "LABEL": "記事の平均閲覧時間"
        },
        "AVG_TIME_LOCKSCREEN": {
          "LABEL": "ロック画面画像の平均閲覧時間"
        },
        "CATEGORY": {
          "LABEL": "カテゴリ"
        },
        "CLICKS": {
          "LABEL": "クリック数"
        },
        "COUNTRIES": {
          "LABEL": "市場"
        },
        "CTR": {
          "LABEL": "CTR"
        },
        "DURATION": {
          "LABEL": "期間（日数）"
        },
        "HUMAN_AUDIT_TIME": {
          "LABEL": "人間監査時間"
        },
        "ID": {
          "COPY_TO_CLIPBOARD": "IDをクリップボードにコピー！",
          "VALUE": "ID: {{value}}",
          "LABEL": "ID"
        },
        "IMPRESSIONS": {
          "LABEL": "インプレッション"
        },
        "LANGUAGE": {
          "LABEL": "言語"
        },
        "OEM": {
          "LABEL": "OEM"
        },
        "REJECTED_REASON": {
          "LABEL": "却下理由"
        },
        "REJECTED_REASON_DESCRIPTION": {
          "LABEL": "却下理由の説明"
        },
        "RESOURCE_TYPE": {
          "LABEL": "リソースタイプ"
        },
        "START_DATE": {
          "LABEL": "開始日"
        },
        "STATUS": {
          "LABEL": "ステータス"
        },
        "TITLE": {
          "EMPTY_LABEL": "タイトルなし"
        }
      },
      "EMPTY": {
        "DESCRIPTION": "キーワードまたはフィルターを変更してみてください。",
        "TITLE": "選択した条件に一致する結果がありません。"
      },
      "ERROR": {
        "DESCRIPTION": "後でもう一度お試しください！",
        "TITLE": "予期しないエラーが発生しました。"
      },
      "FILTERS": {
        "ADVERTISER": {
          "LABEL": "広告主"
        },
        "CATEGORY": {
          "LABEL": "カテゴリ"
        },
        "COUNTRY": {
          "LABEL": "市場"
        },
        "DATEPICKER": {
          "AUTO_AUDIT_TIME": "自動監査時間",
          "START_END_TIME": "開始 / 終了時間",
          "DATE_RANGE": "日付範囲",
          "HUMAN_AUDIT_TIME": "人間監査時間",
          "PRESETS": {
            "ALL": "すべて",
            "CURRENT_MONTH": "今月",
            "LAST_7_DAYS": "過去7日間",
            "NEXT_MONTH": "来月",
            "PREVIOUS_MONTH": "先月",
            "TODAY": "今日"
          },
          "PUBLISH_LABEL": "公開日範囲"
        },
        "LANGUAGE": {
          "LABEL": "言語"
        },
        "SORT_BY": {
          "LABEL": "並び替え"
        },
        "SORT_ORDER": {
          "LABEL": "並び順"
        },
        "STATUS": {
          "LABEL": "ステータス"
        },
        "RESET": "フィルターをリセット"
      },
      "HEADER": "ロック画面キャンペーン",
      "METRICS": {
        "INFO": "すべての指標はキャンペーン開始以来の集計データに基づいています。日付選択は表示データに影響しません。",
        "LABEL": "指標"
      },
      "TOTAL_ELEMENTS": {
        "LABEL": "合計：{{value}}"
      }
    },
    "REPORTS": {
      "LOADING": "レポートを読み込み中...",
      "SELECT_FILTERS": "フィルターを選択してレポートを生成してください。",
      "GENERATE": "生成",
      "GENERATE_TITLE": "レポートを生成",
      "TYPE": {
        "CONTENT": "Content",
        "WORKLOAD": "Workload",
        "AUDIT_RATE": "Audit rate"
      },
      "LIST": {
        "HEADER": "Reports"
      },
      "WORKLOAD": {
        "HEADER": "Workload report"
      },
      "CONTENT": {
        "HEADER": "Content report"
      },
      "AUDIT_RATE": {
        "HEADER": "Audit rate report"
      }
    },
    "SHARED": {
      "DATEPICKER": {
        "END_DATE": "終了日",
        "ENTER_DATE_RANGE": "キャンペーン実施期間",
        "START_DATE": "開始日"
      },
      "SEARCH": {
        "LABEL": "検索"
      },
      "SNACKBAR": {
        "CHECK_DETAILS": "詳細を確認"
      }
    },
    "STATUSES": {
      "ALL": "すべて",
      "APPROVED": "承認済み",
      "CANCELLED": "キャンセル済み",
      "EXPIRED": "期限切れ",
      "IN_REVIEW": "レビュー中",
      "LIVE": "公開中",
      "REJECTED": "拒否"
    }
  },
  "Login": "",
  "New password": "",
  "No results for selected criteria": "",
  "Notification create failed": "",
  "Notification name update failed": "",
  "Password": "",
  "Password doesn't match": "",
  "Password is required": "",
  "Password must contain at least one numeric character": "",
  "Password required": "",
  "Passwords must be at least 8 characters in length": "",
  "Repeat password": "",
  "Reset password": "",
  "Return": "",
  "Role has been changed!": "",
  "Search category name": "",
  "Stores in": "",
  "Target": "",
  "Temporary password": "",
  "Timezone": "",
  "Total conversions": "",
  "Traffic": "",
  "Try again later!": "",
  "Try changing the keywords or filters": "",
  "URL address": "",
  "Uploading": "Uploading",
  "User has been already added!": "",
  "User has been removed!": "",
  "add": "",
  "clear all": "",
  "e": {
    "g": {
      " https://www": {
        "kaikai": {
          "ai": ""
        }
      }
    }
  },
  "label selected": "",
  "labels selected": "",
  "select all": ""
}